module.exports = __webpack_public_path__ + "static/img/yq.f552681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yq.png
// module id = YYpd
// module chunks = 0